module.exports = __webpack_public_path__ + "static/license_en-d3477d8bd65b8129463c6f101fe84487.pdf";